import { useQuery } from '@tanstack/react-query';

import { Skeleton } from '@/components/ui/skeleton';

import { bookingReservationQueries } from '@/queries';

import { EventAttendanceForm } from './EventAttendanceForm';

type RegistrationAttachFormProps = {
  registrationId: number;
  reservationsUrl: string;
  clientsSearchUrl: string;
  clientsUrl: string;
  newClientsUrl: string;
  onClose: () => void;
  onSuccess: () => void;
};

export const RegistrationAttachForm = (props: RegistrationAttachFormProps) => {
  const {
    registrationId,
    reservationsUrl,
    clientsSearchUrl,
    clientsUrl,
    newClientsUrl,
    onClose,
    onSuccess,
  } = props;

  const { data: reservation, isLoading } = useQuery(
    bookingReservationQueries.detail({
      url: reservationsUrl,
      id: registrationId,
    }),
  );

  if (isLoading || !reservation) {
    return <Skeleton className="m-6 h-64" />;
  }

  return (
    <EventAttendanceForm
      reservation={reservation}
      reservationsUrl={reservationsUrl}
      clientsSearchUrl={clientsSearchUrl}
      clientsUrl={clientsUrl}
      newClientsUrl={newClientsUrl}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};
